import { useEffect, useState } from 'react';

const DEFAULT_VISIBILITY = {
  country: '',
  hideInstagram: false,
  loaded: false,
};

let cachedVisibility = null;
let pendingVisibility = null;

export function useRegionalVisibility() {
  const [visibility, setVisibility] = useState(() => cachedVisibility || DEFAULT_VISIBILITY);

  useEffect(() => {
    let cancelled = false;

    loadRegionalVisibility().then((nextVisibility) => {
      if (!cancelled) {
        setVisibility(nextVisibility);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return visibility;
}

async function loadRegionalVisibility() {
  if (cachedVisibility) return cachedVisibility;
  if (pendingVisibility) return pendingVisibility;

  pendingVisibility = fetch('/api/visitor-region', {
    method: 'GET',
    headers: { accept: 'application/json' },
    cache: 'no-store',
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`REGION_HTTP_${response.status}`);
      }
      const payload = await response.json();
      return {
        country: safeCountry(payload?.country),
        hideInstagram: Boolean(payload?.hideInstagram),
        loaded: true,
      };
    })
    .catch(() => ({
      country: '',
      hideInstagram: false,
      loaded: true,
    }))
    .then((nextVisibility) => {
      cachedVisibility = nextVisibility;
      pendingVisibility = null;
      return nextVisibility;
    });

  return pendingVisibility;
}

function safeCountry(value) {
  const normalized = String(value || '').trim().toUpperCase();
  return /^[A-Z]{2}$/.test(normalized) ? normalized : '';
}
